import React from 'react';
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  type?: 'text' | 'email' | 'password' | 'number' | 'search';
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  error?: string;
  label?: string;
  icon?: React.ReactNode;
  className?: string;
  'data-id'?: string;
}
export function Input({
  type = 'text',
  placeholder,
  value,
  onChange,
  disabled = false,
  error,
  label,
  icon,
  className = '',
  'data-id': dataId,
  ...rest
}: InputProps) {
  return <div className={`w-full ${className}`} data-id="element-3295">
      {label && <label className="block text-[12px] font-medium text-[#475569] mb-1.5" data-id="element-3296">
          {label}
        </label>}

      <div className="relative" data-id="element-3297">
        {icon && <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#94A3B8]" data-id="element-3298">
            {icon}
          </div>}

        <input type={type} placeholder={placeholder} value={value} onChange={onChange} disabled={disabled} {...rest} className={`
            w-full h-[40px] px-3 ${icon ? 'pl-10' : ''} 
            bg-white border border-[#CBD5E1] rounded-[6px]
            text-[14px] text-[#0F172A] placeholder:text-[#94A3B8]
            focus:outline-none focus:border-[#0EA5E9] focus:ring-[3px] focus:ring-[#0EA5E9]/20
            disabled:bg-[#F1F5F9] disabled:opacity-60 disabled:cursor-not-allowed
            transition-all duration-200
            ${error ? 'border-[#EF4444] focus:border-[#EF4444] focus:ring-[#EF4444]/20' : ''}
          `} data-id="element-3299" />
      </div>

      {error && <p className="mt-1 text-[12px] text-[#EF4444]" data-id="element-3300">{error}</p>}
    </div>;
}